import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useBetaSignup } from '../context/BetaSignupContext';
import { Loader2 } from 'lucide-react';

const ReferralRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const { setReferralCode, openModal } = useBetaSignup();
  const [referrerName, setReferrerName] = useState(null);

  useEffect(() => {
    const handleReferral = async () => {
      if (code) {
        // Verify the referral code
        try {
          const API_URL = process.env.REACT_APP_BACKEND_URL;
          const response = await fetch(`${API_URL}/api/beta-signup/verify/${code}`);
          const data = await response.json();
          
          if (data.valid) {
            setReferrerName(data.referrer_name);
          }
        } catch (err) {
          console.error('Error verifying referral:', err);
        }

        // Set the referral code in context
        setReferralCode(code);
        
        // Redirect to home and open modal
        navigate('/', { replace: true });
        setTimeout(() => {
          openModal();
        }, 100);
      }
    };

    handleReferral();
  }, [code, setReferralCode, navigate, openModal]);

  return (
    <div className="min-h-screen bg-[#F5F3ED] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#FF8C42] mx-auto mb-4" />
        <p className="text-gray-600">
          {referrerName ? `${referrerName} invited you to Trove...` : 'Loading your invitation...'}
        </p>
      </div>
    </div>
  );
};

export default ReferralRedirect;
